// extracted by mini-css-extract-plugin
module.exports = {"Page":"style_Page__3mWhA"};